import NoSearchIcon from "Assets/Icons/NoSearchIcon";
import SearchCrossIcon from "Assets/Icons/SearchCrossIcon";
import SearchIcon from "Assets/Icons/SearchIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import Typography from "Components/CommonComponents/Typography";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import { Card, Spinner } from "reactstrap";
import { mapToArrayForSelect } from "utilFunctions/helperFunctions/HelperFunction";
import "./PerformanceSearchBar.css";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import { Button } from "reactstrap";
const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

const AutoSearchInput = (props: any) => {
  const { saveGlobalSearchData } = useGlobalSearchContext();
  const navigate = useNavigate();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const { input, setInput } = props;
  const [suggestdata] = useState([]);
  const [tags, setTags] = useState<any[]>([]);
  const inputSearchRef = useRef<HTMLInputElement>(null);
  const handleChange = (e: any) => {
    const { value } = e.target;
    if (value != "") {
      const specialCharacterRegex = /^[A-Za-z0-9 ]+$/;
      // const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const isValid = specialCharacterRegex.test(value);
      if (
        props.mode != "faculty_search" &&
        (!isValid || value.trim().length === 0 || parseInt(value) < 0)
      ) {
        // props.setInputValue && props.setInputValue("");
        props.setIsLoader && props.setIsLoader(false);
        return;
      }
      setInput(value);
      props.setIsLoader && props.setIsLoader(true);
      props.setInputValue && props.setInputValue(value);
      handleSuggestion();
    } else {
      props.setIsLoader && props.setIsLoader(false);
      setInput(value);
      props.setInputValue && props.setInputValue(value);
      handleSuggestion();
    }
  };
  const handleSuggestion = () => {
    const suggestFilterInput = suggestdata.filter((suggest: any) =>
      suggest.email !== null
        ? suggest.email.toLowerCase().includes(input.toLowerCase())
        : null
    );

    const suggestFilterTags = suggestFilterInput.filter(
      (suggest: any) => !tags.includes(suggest.email)
    );
    props.setSuggestions(suggestFilterTags);
  };
  const debouncedSearchTerm = useDebounce(input, 500);
  useEffect(() => {
    if (debouncedSearchTerm) {
      if (debouncedSearchTerm != props.searchName) {
        props.searchData(debouncedSearchTerm);
      }
    }
  }, [debouncedSearchTerm, props.selectedCategory]);
  useEffect(() => {
    if (inputSearchRef.current) {
      inputSearchRef.current.focus();
    }
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const AddTags = (suggest: any) => {
    setTags([suggest.email]);
    props.setTagsList && props.setTagsList([suggest.email]);
    props.setTagsListId && props.setTagsListId([suggest.id]);
    setInput(suggest.name);
    props.setSearchName && props.setSearchName(suggest.name);
    const objforMapToSelect = {
      suggest: suggest,
      keyToSet: "acadToClassMap",
      order: false,
    };
    const newClassArraySelect = mapToArrayForSelect(objforMapToSelect);
    saveGlobalSearchData({
      pathurl: null,
      isBranchHealth: false,
      isStudentHealth: false,
      isPerformance: false,
    });
    const newSuggest = {
      ...suggest,
      acadToClassMap: newClassArraySelect,
      selectedYear: { label: suggest.academicYear, value: suggest.clazz },
    };
    console.log("newSuggest===", newSuggest);
    navigate("/admin/performance/" + newSuggest.psid, {
      replace: true,
      state: {
        selectedStudent: newSuggest,
      },
    });
    props.setSuggestions([]);
  };

  const handleSelectedUser = (suggestedUser: any) => {
    props.onClickHandler(suggestedUser);
    setInput(suggestedUser?.email);
    props.setSearchName && props.setSearchName(suggestedUser.email);
    props.setSuggestions([]);
  };
  const handleSelectedStudent = (suggestedUser: any) => {
    //props.onClickHandler(suggestedUser);
    setInput(suggestedUser?.name);
    props.setSelectedStudent(suggestedUser);
    props.setSearchName && props.setSearchName(suggestedUser.name);
    props.setSuggestions([]);
  };
  const data = React.useMemo(() => props.suggestions, [props.suggestions]);
  console.log(windowDimensions, props.suggestions, "props.suggestions");
  const returnText = (suggest: any) => {
    let result = suggest.name.trim() + ", PSID:" + suggest.psid;
    if (suggest.stream) {
      result += ", " + suggest.stream;
    }
    if (suggest.clazz) {
      result += ", Class:" + suggest.clazz;
    }
    return result;
  };
  return (
    <>
      <div
        className={
          props.mode == "faculty_search"
            ? "facultySearchAutoInputContent"
            : "tags-content"
        }
      >
        <div className="tags-input">
          <div className="position-relative">
            <input
              className="inputAutoSearch"
              disabled={false}
              type={props.mode == "faculty_search" ? "email" : "text"}
              value={input}
              onChange={handleChange}
              placeholder={props.placeholder ? props.placeholder : "Search"}
              ref={inputSearchRef}
            />
            <div className="searchAndCloseIconDiv">
              {props.isLoader ? (
                <Spinner color="info" size="sm"></Spinner>
              ) : (
                <>
                  {input && Boolean(props.suggestions.length) ? (
                    <SearchCrossIcon
                      className="cursorHoverCSS"
                      onClick={() => {
                        props.setSuggestions([]);
                        props.setSearchName(null);
                        setInput("");
                      }}
                    />
                  ) : (
                    <SearchIcon
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </div>

          {input &&
          props.suggestions &&
          Array.isArray(props.suggestions) &&
          props.suggestions.length > 0 ? (
            <div className="tags-suggestions">
              <InfiniteScroll
                className={"searchbarListingInfiniteScroll"}
                dataLength={data.length}
                next={props.nextHandler}
                hasMore={props.hasMore}
                height={"auto"}
                loader={
                  <div className="mx-auto text-center py-5 my-5">
                    {<Spinner color="info"></Spinner>}
                  </div>
                }
              >
                {props.showCategories &&
                props.showCategories === "showCategories" ? (
                  <>
                    <Card>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: "0.5rem",
                        }}
                      >
                        <Button
                          size="sm"
                          outline
                          color="aeslPrimary"
                          onClick={() => {
                            props.setSelectedCategory("Student");
                          }}
                          className="m-0"
                          style={{
                            width: "auto",
                            padding: "0.5rem 1rem",
                            height: "40px",
                          }}
                        >
                          Student
                        </Button>

                        <Button
                          size="sm"
                          outline
                          color="aeslPrimary"
                          onClick={() => {
                            props.setSelectedCategory("faculty_search");
                          }}
                          className="m-0"
                          style={{
                            width: "auto",
                            padding: "0.5rem 1rem",
                            height: "40px",
                          }}
                        >
                          Faculty
                        </Button>

                        <Button
                          size="sm"
                          outline
                          color="aeslPrimary"
                          onClick={() => {
                            console.log(
                              "This button is also getting clicked.Logic with backend for batch searching is yet to be received and to be discussed"
                            );
                          }}
                          className="m-0"
                          style={{
                            width: "auto",
                            padding: "0.5rem 1rem",
                            height: "40px",
                          }}
                        >
                          Batch
                        </Button>
                      </div>
                    </Card>
                  </>
                ) : (
                  <></>
                )}
                {props.suggestions.map((suggest: any, index: any) => (
                  <div
                    key={index}
                    className="suggestion-item"
                    onClick={() =>
                      ["faculty_search", "branchHealth"].includes(props.mode)
                        ? handleSelectedUser(suggest)
                        : ["studentIssue"].includes(props.mode)
                        ? handleSelectedStudent(suggest)
                        : AddTags(suggest)
                    }
                  >
                    <Typography variant="body3" color="black">
                      {props.mode == "faculty_search" ? (
                        `${suggest.name} , Employee Id: + ${
                          suggest.employeeId && suggest.employeeId !== null
                            ? suggest.employeeId
                            : " "
                        }`
                      ) : (
                        <>{returnText(suggest)}</>
                      )}
                    </Typography>
                  </div>
                ))}
              </InfiniteScroll>
            </div>
          ) : (
            input != "" &&
            !props.isLoader &&
            props.searchName != input && (
              <div
                className="noResultFound"
                style={{ flexDirection: "column" }}
              >
                <div>
                  {props.showCategories &&
                  props.showCategories === "showCategories" ? (
                    <>
                      <Card>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "0.5rem",
                          }}
                        >
                          <Button
                            size="sm"
                            outline
                            color="aeslPrimary"
                            onClick={() => {
                              props.setSelectedCategory("Student");
                            }}
                            className="m-0"
                            style={{
                              width: "auto",
                              padding: "0.5rem 1rem",
                              height: "40px",
                            }}
                          >
                            Student
                          </Button>

                          <Button
                            size="sm"
                            outline
                            color="aeslPrimary"
                            onClick={() => {
                              props.setSelectedCategory("faculty_search");
                            }}
                            className="m-0"
                            style={{
                              width: "auto",
                              padding: "0.5rem 1rem",
                              height: "40px",
                            }}
                          >
                            Faculty
                          </Button>

                          <Button
                            size="sm"
                            outline
                            color="aeslPrimary"
                            onClick={() => {
                              console.log(
                                "This button is also getting clicked.Logic with backend for batch searching is yet to be received and to be discussed"
                              );
                            }}
                            className="m-0"
                            style={{
                              width: "auto",
                              padding: "0.5rem 1rem",
                              height: "40px",
                            }}
                          >
                            Batch
                          </Button>
                        </div>
                      </Card>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div>
                  <NoResultFoundSearch
                    primaryMessage="No result found"
                    secondaryMessage={
                      props.mode == "faculty_search"
                        ? "No faculty data match your search"
                        : "No student data match your search, try changing the filters"
                    }
                  >
                    <NoSearchIcon></NoSearchIcon>
                  </NoResultFoundSearch>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};
const hasNumbers = (t: any) => {
  const regex = /\d/g;
  return regex.test(t);
};
// Debounce function
function useDebounce(value: any, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    if (value === "") {
      setDebouncedValue("");
      return;
    }
    if (hasNumbers(value) && value.length >= 7) {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }
    if (!hasNumbers(value) && value.length >= 3) {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [value, delay]);
  return debouncedValue;
}

export default AutoSearchInput;
